function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThinArrow = function SvgThinArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M23 30 9 16 23 2",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  }));
};
export default SvgThinArrow;